export default "__VITE_ASSET__31ade170__"